import { testimonials, siteInfo } from "@/mocks/siteContent";
import SectionHeader from "./SectionHeader";

export default function Reviews() {
  return (
    <section id="reviews" className="w-full py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="用户口碑"
          title="百万漫画迷的共同选择"
          desc="来自不同题材爱好者的真实反馈。高清画质、清晰分类与每日更新，让每一位读者都能在这里找到属于自己的追更方式。"
        />

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col justify-between rounded-xl border border-background-200 bg-background-50 p-5"
            >
              <div>
                <div className="flex items-center gap-1 text-secondary-500">
                  {[0, 1, 2, 3, 4].map((i) => (
                    <i key={i} className="ri-star-fill" aria-hidden="true" />
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">"{t.text}"</blockquote>
              </div>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <img
                  src={t.avatar}
                  alt={`${t.name}的头像`}
                  className="h-10 w-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-6 flex flex-col items-center justify-between gap-4 rounded-xl bg-gradient-to-r from-primary-500 to-primary-400 px-6 py-6 text-white sm:flex-row">
          <div>
            <p className="font-heading text-lg">还没有找到想看的漫画？</p>
            <p className="mt-1 text-sm text-white/85">
              {siteInfo.brand}持续更新全题材作品，进入热门推荐，开启你的追更之旅。
            </p>
          </div>
          <a
            href="#hot"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-primary-600 transition-colors hover:bg-background-100"
          >
            <i className="ri-arrow-right-line" aria-hidden="true" />
            去逛逛热门推荐
          </a>
        </div>
      </div>
    </section>
  );
}